import React, { useEffect, useState } from "react";
import "./VendorInfoPage.css";
import {
  FaImage,
  FaRegFileAlt,
  FaMapMarker,
  FaStar,
  FaStarHalfAlt,
  FaGrinStars,
  FaRupeeSign,
} from "react-icons/fa";
import { FaPerson } from "react-icons/fa6";
import { useNavigate } from "react-router";
import AOS from "aos";
import "aos/dist/aos.css";
import useAuth from "../../../hooks/useAuth";
import { useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const VendorInfoPage = () => {
  const location = useLocation();
  const { vendor } = location.state || { vendor: {} };
  console.log("00", vendor);
  const navigate = useNavigate();
  const { isAuthenticated, redirectToLogin } = useAuth();

  const [animateBars, setAnimateBars] = useState(false);

  useEffect(() => {
    if (!isAuthenticated()) {
      redirectToLogin();
    }
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
    setAnimateBars(true);
  }, [isAuthenticated, redirectToLogin]);

  const renderImages = () => {
    const images = JSON.parse(vendor.image || "[]");
    return images.map((img, index) => (
      <div className="col-lg-4 col-md-6" key={index}>
        <div className="card">
          <div className="card-img">
            <img
              src={`${BASE_URL}/uploads/${img.filename}`}
              alt=""
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    ));
  };

  const renderBannerImage = () => {
    const bannerImages = JSON.parse(vendor.BannerImage || "[]");
    if (bannerImages.length > 0) {
      return (
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              src={`${BASE_URL}/BannerUploads/${bannerImages[0].filename}`}
              alt="Banner Image "
              className="d-block w-100"
            />
          </div>
        </div>
      );
    }
    return null;
  };

  const renderVideo = () => {
    let videoData = null;
    try {
      videoData = JSON.parse(vendor.Video || null);
    } catch (error) {
      console.error("Error parsing video JSON:", error);
    }
    if (videoData) {
      const videoSrc = `${BASE_URL}/VideoUploads/${videoData.filename}`;
      return <video controls className="w-100" src={videoSrc}></video>;
    }
    return null;
  };

  return (
    <div id="vendorInfoPage">
      <div>
        <div className="carousel slide" data-ride="carousel" data-aos="fade-up">
          {renderBannerImage()}
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            {/* Vendor Type Section */}
            <div
              className="content-section"
              id="vendor-type"
              data-aos="fade-right"
            >
              <h1 className="vendor-name">{vendor.ServiceName}</h1>
              <h3 className="vendor-location">
                <FaMapMarker /> {vendor.City}
              </h3>
              <h4> {vendor.Address}</h4>
              <h4 className="vendor-rating">
                <FaStar className="gold-star" />
                <FaStar className="gold-star" />
                <FaStar className="gold-star" />
                <FaStar className="gold-star" />
                <span> Rating</span>
              </h4>
            </div>
            {/* Services Section */}
            <div
              className="content-section position-sticky sticky-nav"
              id="services"
              data-aos="fade-left"
            >
              <ul className="nav flex-row nav-pills menu-sidebar">
                <li className="nav-item">
                  <ScrollLink
                    className="nav-link"
                    to="about-us"
                    smooth={true}
                    duration={100}
                    offset={-80}
                  >
                    <FaRegFileAlt /> About Us
                  </ScrollLink>
                </li>
                <li className="nav-item">
                  <ScrollLink
                    className="nav-link"
                    to="gallery"
                    smooth={true}
                    duration={500}
                    offset={-70}
                  >
                    <FaImage /> Gallery
                  </ScrollLink>
                </li>
                <li className="nav-item">
                  <ScrollLink
                    className="nav-link"
                    to="video"
                    smooth={true}
                    duration={500}
                    offset={-70}
                  >
                    <FaRegFileAlt /> Video
                  </ScrollLink>
                </li>
                <li className="nav-item">
                  <ScrollLink
                    className="nav-link"
                    to="review"
                    smooth={true}
                    duration={500}
                    offset={-70}
                  >
                    <FaStar /> Review
                  </ScrollLink>
                </li>
              </ul>
            </div>

            {/* About Us Section */}
            <div
              className="content-section"
              id="about-us"
              data-aos="fade-right"
            >
              <h3>
                <FaRegFileAlt /> About Us
              </h3>
              <p>{vendor.ServiceDescription}</p>
            </div>

            {/* Gallery Section */}
            <div className="content-section" id="gallery" data-aos="fade-left">
              <h3>
                <FaImage /> Gallery
              </h3>
              <div className="container">
                <div className="row gy-4">{renderImages()}</div>
              </div>
            </div>

            {/* Video Section */}
            <div className="content-section" id="video" data-aos="fade-left">
              <h3>
                <FaRegFileAlt /> Video
              </h3>
              <div className="ratio ratio-16x9">{renderVideo()}</div>
            </div>

            {/* Review Section */}
            <div className="content-section" id="review" data-aos="fade-right">
              <h3>
                <FaStarHalfAlt /> Review
              </h3>
              <div className="review-section">
                <span className="progress-label">
                  <FaGrinStars className="icon" /> Quality Service
                </span>
                <div
                  className={`progress mb-2 ${
                    animateBars ? "progress-animation" : ""
                  }`}
                >
                  <div
                    className="progress-bar bg-success"
                    role="progressbar"
                    style={{ width: "25%" }}
                    aria-valuenow={25}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    25%
                  </div>
                </div>
                <span className="progress-label">
                  <FaStar className="icon" /> Value of Money
                </span>
                <div
                  className={`progress mb-2 ${
                    animateBars ? "progress-animation" : ""
                  }`}
                >
                  <div
                    className="progress-bar bg-info"
                    role="progressbar"
                    style={{ width: "50%" }}
                    aria-valuenow={50}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    50%
                  </div>
                </div>
                <span className="progress-label">
                  <FaPerson className="icon" /> Availability
                </span>
                <div
                  className={`progress mb-2 ${
                    animateBars ? "progress-animation" : ""
                  }`}
                >
                  <div
                    className="progress-bar bg-warning"
                    role="progressbar"
                    style={{ width: "75%" }}
                    aria-valuenow={75}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    75%
                  </div>
                </div>
                <span className="progress-label">
                  <FaRupeeSign className="icon" /> Budget Friendly
                </span>
                <div
                  className={`progress mb-2 ${
                    animateBars ? "progress-animation" : ""
                  }`}
                >
                  <div
                    className="progress-bar bg-danger"
                    role="progressbar"
                    style={{ width: "100%" }}
                    aria-valuenow={100}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    100%
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            {/* Appointment Form */}
            <div className="sticky-top appointment-form" data-aos="fade-up">
              <span className="appointment-heading">Book an Appointment</span>
              <form>
                <div className="mb-3 mt-5">
                  <label htmlFor="date" className="form-label">
                    Date
                  </label>
                  <input type="date" className="form-control" id="date" />
                </div>
                <div className="mb-3">
                  <label htmlFor="note" className="form-label">
                    Note
                  </label>
                  <textarea
                    className="form-control"
                    id="note"
                    placeholder="Note"
                    rows="4"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={() => navigate("/Book")}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorInfoPage;
